import React from 'react';
import PropTypes from 'prop-types';

export default class Iframe extends React.Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  onChange(content) {
    const { onChange, item } = this.props;
    onChange({
      ...item,
      content,
    });
  }

  render() {
    const { item } = this.props;

    const nitem = {
      content: {},
      ...item,
    };

    if (typeof nitem === 'undefined') {
      return <div />;
    }

    return (
      <div>
        <input
          className="form-control"
          defaultValue={nitem.content.url}
          onChange={(e) => {
            this.onChange({ ...nitem.content, url: e.target.value });
          }}
        />
      </div>
    );
  }
}

Iframe.propTypes = {
  item: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
